/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface LakeApiKey {
  id?: number;
  active?: boolean;
  name?: string;
  accountId?: number;
  publicKey?: string;
  permission?: LakeApiKey.PermissionEnum;
  cidr?: string;
}
export namespace LakeApiKey {
  export const PermissionEnum = {
    Create: 'CREATE',
    Read: 'READ',
  } as const;
  export type PermissionEnum = (typeof PermissionEnum)[keyof typeof PermissionEnum];
}
